// extracted by mini-css-extract-plugin
export default {"sidebar":"SidebarOrganisation_sidebar__H+asN","sidebar--narrow":"SidebarOrganisation_sidebar--narrow__g1JjI"};